import { render, staticRenderFns } from "./paginator.vue?vue&type=template&id=1855bcff&"
import script from "./paginator.vue?vue&type=script&lang=js&"
export * from "./paginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports